export const unindent = (str) => {
  const lines = str.replace(/^\n/, "").split("\n");
  const indent = lines[0].match(/^\s*/)[0];

  return lines.map(line => line.replace(indent, "")).join("\n");
}
